export const GRAY_JOB_ISSUE_TRANSACTION_REQUEST = 'GRAY_JOB_ISSUE_TRANSACTION_REQUEST';
export const GRAY_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE = 'GRAY_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE';
export const GET_GRAY_JOB_ISSUE_TRANSACTIONS_TAKA_NO = 'GET_GRAY_JOB_ISSUE_TRANSACTIONS_TAKA_NO';
export const GET_GRAY_JOB_ISSUE_TRANSACTIONS = 'GET_GRAY_JOB_ISSUE_TRANSACTIONS';